<template>
  <div>
    <crud
      mode="ServerSide"
      deleteMode="hard"
      :update-many-mode="false"
      :custom-buttons="buttons"
      :resolverType="resolverType"
      :list="list"
      :get="get"
      :create="create"
      :update="update"
      :remove="remove"
      :page-title="pageTitle"
      :fields-info="fieldsInfo"
      :details-title="$t('detailsTitle')"
      :edit-button="false"
      :watch-for-creation="true"
      primary-key="id"
    >
    </crud>
    <item-details
      :fields="itemFields"
    ></item-details>
  </div>
</template>

<script>
import Crud from '@/utils/crud/components/Crud.vue'
import FieldsInfoMixin from './mixins/fields'
import LocalesMixin from './mixins/locales'
import ItemDetails from './components/ItemDetailsServer.vue'
import ExtendedControllerMixin from '@/utils/crud/mixins/extended-controller'

import {
  mapMutations,
  mapActions,
} from 'vuex'

export default {
  mixins: [
    ExtendedControllerMixin,
    FieldsInfoMixin,
    LocalesMixin,
  ],
  components: {
    Crud,
    ItemDetails,
  },
  data () {
    return {
      resolverType: 'http',
      list: 'listOpticheckTasks',
      get: 'getOpticheckTask',
      create: 'createOpticheckTask',
      update: 'updateOpticheckTask',
      remove: 'deleteOpticheckTask',
      pageTitle: 'opticheck.tasks',
    }
  },
  computed: {
    buttons () {
      return [
        {
          name: 'goToItem',
          icon: 'forward',
          color: 'primary',
          text: this.$t('buttons.goToItem'),
        },
      ]
    },
  },
  methods: {
    ...mapMutations([
      'alertSuccess',
      'alertError',
    ]),
    ...mapActions('crud', [
      'updateItem',
      'storeItem',
    ]),
  },
}

</script>
